import React from "react";
import SimpleSectionHeader from "./SimpleSectionHeader";

const TermsAndConditions = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Full-width Section Header */}
      <div className="w-full bg-white">
        <SimpleSectionHeader title="Terms and Conditions" />
        <div className="flex justify-center mt-2"></div>
      </div>

      {/* Main Content Container */}
      <div className="py-10 px-4 sm:px-10">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 sm:p-12">
          <div className="mb-6">
            {/* <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Personal Information
            </h2> */}
            <p className="text-gray-700 mb-4">
              We recommend that you carefully go through our Terms of Use, to
              better understand the different features of our service, and
              information about our Website. Click the links below to access the
              information within.
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>
                Acceptance Of Terms Of UseThese "Terms Of Use" govern your use
                of the Booksatdoorsteps™ Website hereinafter referred to as
                "Service". The Service is owned and operated by
                Booksatdoorsteps™ Service and Manya Knowledge Services
                (hereinafter referred to as "Booksatdoorsteps™") and is offered
                to you (hereinafter referred to as "Member") .By clicking the
                box entitled "I Have Read and Accept the Terms of Use" as part
                of the registration process, Members accept all items in the
                Terms of Use and agree to abide by and be legally bound by the
                Terms of Use.By browsing, visiting and using Booksatdoorsteps™
                Website, you accept and agree to abide by these Terms of Use. If
                you do not agree to these Terms of Use, you should not use the
                Booksatdoorsteps Website.These Terms of Use are an ongoing
                contract between you and Booksatdoorsteps™ and apply to your use
                of the Booksatdoorsteps™ service and Website. These Terms of Use
                affect your rights and you should read them carefully.
              </li>
              <li>
                Changes To Terms Of UseBooksatdoorsteps™ reserves the right,
                from time to time, with or without notice to you, to change
                these Terms of Use in our sole and absolute discretion. The most
                current version of these Terms of Use can be reviewed by
                clicking on the "Terms of Use" located at the bottom of the
                pages of the Booksatdoorsteps™ Website. The most current version
                of the Terms of Use will supersede all previous versions. Your
                use of the Booksatdoorsteps™ Website or continued use of our
                service after changes are made means that you agree to be bound
                by such changes.
              </li>
              <li>
                Privacy Any information submitted on the Booksatdoorsteps™
                Website is subject to our Privacy Policy, the terms of which are
                incorporated herein. Please review our Privacy Policy to
                understand our practices (located at the bottom of the pages of
                the Booksatdoorsteps™ Website).
              </li>
              <li>
                How Booksatdoorsteps service worksBooksatdoorsteps™ is an online
                subscription based rental service that allows its members to
                rent books through its website located at
                http://www.Booksatdoorsteps.com. To use Booksatdoorsteps™, one
                will have to register with Booksatdoorsteps.com™ to create an
                account and become its member. A member can then browse/search
                books he/she would like to read, and add them to his/her
                Booklist. Once payment has been received or we have made an
                arrangement with the member to pickup the payment at the time of
                delivery, the first set of books will be delivered to the member
                at the shipping address provided at the time of registration.
                The number of books delivered at a time by Booksatdoorsteps™ is
                as per his/her membership plan. Once a member is done with the
                first set of books, he/she goes to www.Booksatdoorsteps.com and
                navigates to "My Booklist" tab and click on "Pickup" or "Pickup
                and Deliver" button.Booksatdoorsteps™ will pickup the previous
                set of books from the members shipping address, and deliver the
                next set of books (for "pickup and deliver"), within two
                business days.
              </li>
              <li>
                My BooklistBooks that you select to rent will be placed into
                your Booklist. You may add books or adjust the sequence of books
                in the Booklist at any time. You must have at least 10 books in
                your Booklist. Click the "My Booklist" tab to make adjustments,
                review requested books or to see which books you currently have.
                We will determine which books to send you based on the books in
                your Booklist and the priority in which you have listed them. We
                endeavor to deliver the books listed highest in your Booklist;
                however when availability is limited, we may ship you books
                lower in your Booklist. Adjustments made to your Booklist may
                not immediately impact your next delivery. In certain instances
                you may have adjusted your Booklist before you have received a
                delivery message when in fact a delivery was already processed.
                The adjustments will, however, impact subsequent deliveries.
              </li>
              <li>
                Allocation and Delivery PolicyWe reserve the right to allocate
                and deliver books among our members in any manner that we, in
                our sole and absolute discretion, determine. In addition, we
                will, in our sole and absolute discretion, determine the
                quantity of books we purchase for any particular title and the
                level of staffing and number of deliveries to be processed at
                each distribution centre. As a result, we may not always send
                you the top choices from your queue, and we may not ship out
                your next book(s) on the same day that we receive one from you.
                At present, our goal is to deliver you the book(s) listed
                highest in your Booklist. Often, on the same day that we receive
                a book(s) from you, we will deliver the next available book(s)
                from your Booklist. In certain instances, your next available
                book(s) will not be delivered until at least one business day
                following our receipt of your returned book(s). Other factors
                that may affect delivery times, include, but are not limited to,
                (i) the distance between the distribution centre from which your
                book(s) was issued and your delivery address, (ii) the timing of
                your placement or adjustment of books in your Booklist. We do
                not process returns or deliveries on National Holidays. We make
                no guarantee as to the shipping and delivery of book(s) and may
                in our sole and absolute discretion, change our business
                practice regarding allocation, delivery and shipping, without
                notice. We may from time to time revise these Terms of Use but
                we will not necessarily provide you notice of the revisions. It
                is up to you to review the Terms of Use frequently to determine
                if there have been any changes made.
              </li>
              <li>
                Return of Rented BooksBooksatdoorsteps™ reserves the right to
                request return of any and all book(s) in the possession of
                Members at any time. Members understand and agree to promptly
                return any book(s) to Booksatdoorsteps™ upon request, and that
                failure to do so within five days of the request makes Members
                liable for the cost of those book(s) plus 50% of that cost as a
                handling charge, for which Booksatdoorsteps™ reserves the right
                to charge the Member's refundable security deposit.
              </li>
              <li>
                No due dates or late feesProvided you continue to be a paying
                member of our service, you may keep the book(s) delivered to you
                as long as you like. You will be required to return the books
                within 5 days following any cancellation of the service or be
                subject to charge for unreturned book(s). Also, you may be
                charged for book(s) that you lose or damage. In the event that
                the number of lost book(s) on your account becomes excessive, as
                we may determine in our sole and absolute discretion, we will
                notify you that your account has been placed on hold for review
                and may charge your Payment Method for the estimated cost of the
                lost book(s). We will alert you of any potential charges prior
                to charging your Payment Method.
              </li>
              <li>
                MembershipUpon becoming a Booksatdoorsteps™ member, members
                become responsible for paying periodic subscription fees
                according to the then current billing terms and subscription
                plan. Subscription fees are non-refundable.
              </li>
              <li>
                Automatic renewalYour Booksatdoorsteps™ subscription will be
                automatically renewed on a monthly basis. We will bill the
                monthly subscription fee plus any applicable tax to the Payment
                Method you provide to us during registration (or to a different
                Payment Method if you change your account information). Your
                membership will automatically renew for successive monthly
                subscriptions, without prior notice to you, unless and until you
                cancel your membership or we terminate it. You must cancel your
                membership before it renews each month in order to avoid billing
                of the next month's subscription fees to your Payment Method.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
